import { createFileRoute } from "@tanstack/react-router";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { LAST_UPDATED_TERMS_OF_SERVICE } from "@/config/constants";
import TermsOfServiceContent from "@/components/drawers/content/TermsOfServiceContent";

export const Route = createFileRoute("/_home/termsOfService")({
  component: TermsOfService,
});

function TermsOfService() {
  return (
    <Card className="col-span-12 sm:col-span-10 sm:col-start-2 md:col-span-8 md:col-start-3 lg:col-span-6 lg:col-start-4">
      <CardHeader className="pb-0">
        <CardTitle asHeading>Terms of Service</CardTitle>
        <CardDescription>Last updated: {LAST_UPDATED_TERMS_OF_SERVICE}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-6">
        <TermsOfServiceContent />
      </CardContent>
    </Card>
  );
}
